var map = {
	"./400x300x200-125F11.jfif": 45,
	"./kutii_gashi_drob1.jfif": 2547,
	"./legen_40ltr_simo.jpg": 5085,
	"./reshetka_boya.jpg": 5645,
	"./vana_boya.jpg": 6402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6223;